import { Injectable } from '@angular/core';
import { Agent, AgentInfo } from '../interfaces/agent.interface';

interface IAgentInfo {
    [key: string]: Agent
}

@Injectable()
export class AgentListInfo {
    private _agentInfo: IAgentInfo = {};
    private _agentTimes: any = {};
    private _agentOrder: string[] = [];

    constructor() { }

    AddAgentInfoToList = (agentInfo: any[] | null): void => {
        if (agentInfo != null) {
            agentInfo.forEach((info: Agent) => {
                this.InternalAddInfoToList(info);
            });
        }
    }

    AddSingleAgentInfoToList = (agentInfo: any | null): void => {
        if (agentInfo != null) {
            this.InternalAddInfoToList(agentInfo);
        }
    }

    private InternalAddInfoToList = (agentInfo: any): void => {
        const info: Agent = agentInfo;
        info.IsViolationHistoryLoadingComplete = false;
        info.InitialViolationsLoaded = false;
        info.isSelected = false;
        info.FullName = `${info.AgentFirstName} ${info.AgentLastName}`;
        info.AgentTime = this._agentTimes[info.LanID];

        this._agentInfo[info.LanID] = info;
    }

    GetAgentInfo = (lanid: string): Agent | null => {
        return this._agentInfo[lanid];
    }

    GetAgentInfoFromAvayaLoginId = (avayaLoginId: string): Agent | undefined => {
        return Object.values(this._agentInfo).find(info => info.AvayaLoginId === avayaLoginId);
    }

    UpdateAgentInfo = (info: AgentInfo | null): void => {
        if (info != null) {
            if (this._agentInfo[info.LanID] != null) {
                this._agentInfo[info.LanID].Accuracy = info.Accuracy;
                this._agentInfo[info.LanID].AgentAuxCodes = info.AgentAuxCodes;
                this._agentInfo[info.LanID].AgentCurrentAuxCode = info.AgentCurrentAuxCode;
                this._agentInfo[info.LanID].AgentFeatures = info.AgentFeatures;
                this._agentInfo[info.LanID].AgentFirstName = info.AgentFirstName;
                this._agentInfo[info.LanID].AgentIndividualFeatures = info.AgentIndividualFeatures;
                this._agentInfo[info.LanID].AgentLastName = info.AgentLastName;
                this._agentInfo[info.LanID].AgentProfile = info.AgentProfile;
                this._agentInfo[info.LanID].AgentRole = info.AgentRole;
                this._agentInfo[info.LanID].AgentStatus = info.AgentStatus;
                this._agentInfo[info.LanID].AgentTeamId = info.AgentTeamId;
                this._agentInfo[info.LanID].AgentTeamName = info.AgentTeamName;
                this._agentInfo[info.LanID].ArchivedAgentsList = info.ArchivedAgentsList;
                this._agentInfo[info.LanID].AvayaLoginId = info.AvayaLoginId;
                this._agentInfo[info.LanID].ConnectionTime = info.ConnectionTime;
                this._agentInfo[info.LanID].DeviceInfo = info.DeviceInfo;
                this._agentInfo[info.LanID].DisplayInSupervisorUI = info.DisplayInSupervisorUI;
                this._agentInfo[info.LanID].EmailId = info.EmailId;
                this._agentInfo[info.LanID].Hierarchy = info.Hierarchy;
                this._agentInfo[info.LanID].Ip = info.Ip;
                this._agentInfo[info.LanID].IsConnected = info.IsConnected;
                this._agentInfo[info.LanID].IsLoggedIn = info.IsLoggedIn;
                this._agentInfo[info.LanID].IsScreenBlocked = info.IsScreenBlocked;
                this._agentInfo[info.LanID].IsStealthModeActivated = info.IsStealthModeActivated;
                this._agentInfo[info.LanID].LanID = info.LanID;
                this._agentInfo[info.LanID].LastStateUpdate = info.LastStateUpdate;
                this._agentInfo[info.LanID].Latitude = info.Latitude;
                this._agentInfo[info.LanID].Longitude = info.Longitude;
                this._agentInfo[info.LanID].PinnedAgentsList = info.PinnedAgentsList;
                this._agentInfo[info.LanID].PrimarySupervisorId = info.PrimarySupervisorId;
                this._agentInfo[info.LanID].PrimarySupervisorLanId = info.PrimarySupervisorLanId;
                this._agentInfo[info.LanID].ProfilePicUrl = info.ProfilePicUrl;
                this._agentInfo[info.LanID].QRVerified = info.QRVerified;
                this._agentInfo[info.LanID].TeamMembers = info.TeamMembers;
                this._agentInfo[info.LanID].TeamsInHierarchy = info.TeamsInHierarchy;
                // this._agentInfo[info.LanID].IsArchived = info.IsArchived;
                // this._agentInfo[info.LanID].IsPinned = info.IsPinned;

                if (info.ProfilePicUrl != null) {
                    this._agentInfo[info.LanID].AgentProfilePic = info.ProfilePicUrl;
                }
            }
        }
    }

    UpdateLoggedInStatus = (lanid: string, IsLoggedIn: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsLoggedIn = IsLoggedIn;
        }
    }

    UpdateScreenblockStatus = (lanid: string, isScreenBlocked: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsScreenBlocked = isScreenBlocked;
        }
    }

    GetScreenblockStatus = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].IsScreenBlocked;
        }
        else {
            return false;
        }
    }

    UpdateStealthModeActivatedStatus = (lanid: string, IsStealthModeActivated: boolean) => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsStealthModeActivated = IsStealthModeActivated;
        }
    }

    UpdateStealthModeRequestedStatus = (lanid: string, IsStealthModeRequested: boolean) => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsStealthModeRequested = IsStealthModeRequested;
        }
    }

    UpdateCurrentAuxCode = (lanid: string, auxCode: string): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].AgentCurrentAuxCode = auxCode;
        }
    }

    GetAvayaLanIdFromAgentLanId = (lanid: string) => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].AvayaLoginId;
        }
        else {
            return "";
        }
    }

    ClearAgentList = (): void => {
        this._agentInfo = {};
    }

    GetAllLanId = (): string[] => {
        return Object.keys(this._agentInfo);
    }

    DoesKeyExist = (lanId: string): boolean => {
        if (this._agentInfo[lanId] != null) {
            return true;
        }
        else {
            return false;
        }
    }

    AddAgentTime = (times: any): void => {
        this._agentTimes = times;
    }

    GetAllAgentInfo = (): Agent[] => {
        return Object.values(this._agentInfo);
    }

    GetAgentCount = (): number => {
        return Object.keys(this._agentInfo).length;
    }

    UpdateLoginStatusMessage = (lanid: string, text: string) => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].LoginStatus = text;
        }
    }

    GetLoginStatusMessage = (lanid: string): string => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].LoginStatus;
        }
        else
            return "";
    }

    UpdateUploadLogStatus = (lanid: string, status: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].UploadLogStatus = status;
        }
    }

    UpdateChatEnabled = (lanid: string, isEnabled: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].ChatEnabled = isEnabled;
        }
    }

    IsArchived = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].IsArchived;
        }
        else
            return false;
    }

    UpdateIsArchived = (lanid: string): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsArchived = !this._agentInfo[lanid].IsArchived;
        }
    }

    UpdateViolationHistoryLoadingStatus = (lanid: string, isComplete: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsViolationHistoryLoadingComplete = isComplete;
        }
    }

    UpdateInitialViolationsLoadedStatus = (lanid: string, isComplete: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].InitialViolationsLoaded = isComplete;
        }
    }

    AreInitialViolationsLoaded = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].InitialViolationsLoaded;
        }
        else
            return false;
    }

    IsViolationHistoryLoadingComplete = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].IsViolationHistoryLoadingComplete;
        }
        else
            return false;
    }

    UpdateConnectionTime = (lanid: string, time: Date): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].ConnectionTime = time;
        }
    }

    UpdateAgentTime = (lanid: string, time: any): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].AgentTime = time;
        }
    }

    UpdateIsConnectedStatus = (lanid: string, isConnected: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsConnected = isConnected;
        }
    }

    GetAgentFirstName = (lanid: string): string => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].AgentFirstName;
        }
        else
            return "";
    }

    UpdateIsSelected = (lanid: string, isSelected: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            //Mark all isSelected as false
            for (let [key, value] of Object.entries(this._agentInfo)) {
                value.isSelected = false;
                this._agentInfo[key] = value;
            }

            this._agentInfo[lanid].isSelected = isSelected;
        }
    }

    UpdateViolations = (lanid: string, violations: { [key: string]: number }): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].Violations = violations;
        }
    }

    UpdateViolationKeys = (lanid: string, violationKeys: string[]): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].ViolationKeys = violationKeys;
        }
    }

    DoesAgentExistInOrderList = (lanid: string): boolean => {
        return this._agentOrder.includes(lanid);
    }

    AddAgentToOrderList = (lanid: string): void => {
        this._agentOrder.push(lanid);
    }

    MoveAgentToTopOfOrderList = (lanid: string): void => {
        //If there is only one entry in the list then there is no use of sorting
        if (Object.entries(this._agentOrder).length <= 1) {
            return;
        }

        //Remove the agent from the list
        this._agentOrder = this._agentOrder.filter((_lanid: string) => _lanid !== lanid);

        if (this._agentInfo[lanid] != null && this._agentInfo[lanid].IsPinned === true) {
            //If the agent we are moving to the top is a pinned agent
            //Then we directly move the agent to the top of the list
            this._agentOrder.unshift(lanid);
        }
        else {
            //If the agent is not a pinned agent
            //Then we need to bring this agent on top of the non-pinned agents
            let index: number = -1;

            //Find the index of the first non-pinned agent
            this._agentOrder.find((lanid: string, _index: number) => {
                if (this._agentInfo[lanid] != null && this._agentInfo[lanid].IsPinned === false) {
                    index = _index;
                    return true;
                }
                else {
                    return false;
                }
            });

            if (index === 0) {
                //This means the first agent itself is a non-pinned agent i.e. there are no pinned agents
                //We directly move the agent to the top of the list
                this._agentOrder.unshift(lanid);
            }
            else {
                //This means the first non-pinned agent is somewhere in between
                this._agentOrder.splice(index, 0, lanid);
            }
        }
    }

    GetOrderList = (): string[] => {
        return this._agentOrder;
    }

    UpdateProfilePicture = (lanid: string, url: string): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].AgentProfilePic = url;
            this._agentInfo[lanid].ProfilePicUrl = url;
        }
    }

    UpdateScreenGrabRequestStatus = (lanid: string, status: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsScreenGrabRequestSent = status;
        }
    }

    GetScreenGrabRequestStatus = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].IsScreenGrabRequestSent;
        }
        else
            return false;
    }

    UpdateCheckInRequestStatus = (lanid: string, status: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsCheckInRequestSent = status;
        }
    }

    GetCheckInRequestStatus = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].IsCheckInRequestSent;
        }
        else
            return false;
    }

    UpdatePinnedStatus = (lanid: string, isPinned: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsPinned = isPinned;
        }
    }

    GetPinnedStatus = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].IsPinned;
        }
        else {
            return false;
        }
    }

    UpdateArchivedStatus = (lanid: string, isArchived: boolean): void => {
        if (this._agentInfo[lanid] != null) {
            this._agentInfo[lanid].IsArchived = isArchived;
        }
    }

    GetArchivedStatus = (lanid: string): boolean => {
        if (this._agentInfo[lanid] != null) {
            return this._agentInfo[lanid].IsArchived;
        }
        else {
            return false;
        }
    }

    UpdateNotificationIconVisibilityStatus = (lanid: string, showIcons: boolean): void => {
        if (this._agentInfo[lanid] != null)
            this._agentInfo[lanid].ShowNotificationIcons = showIcons;
    }

    GetProfilePicLoadRetryCount = (lanid: string): number => {
        if (this._agentInfo[lanid] != null)
            return this._agentInfo[lanid].ProfilePicLoadRetryCount;
        else return 0;
    }

    IncrementProfilePicLoadRetryCount = (lanid: string): void => {
        if (this._agentInfo[lanid] != null)
            this._agentInfo[lanid].ProfilePicLoadRetryCount++;
    }

    UpdateEventNames = (lanid: string, eventName: string): void => {
        if (this._agentInfo[lanid] != null)
            this._agentInfo[lanid].EventNames.add(eventName);
    }

    GetEventNames = (lanid: string): Set<string> => {
        if (this._agentInfo[lanid] != null)
            return this._agentInfo[lanid].EventNames;
        else return new Set();
    }
}